import { Address, VehicleId } from '../../sharedComponents/common.types';
import { ServiceOrderVehicleModel, ServiceType } from '../shared/commonServiceOrder.types';

export enum ServiceOptionStatus {
    OPEN = 'open',
    CLOSED = 'closed',
    CANCELLED = 'cancelled',
}

export type ServiceOptionPage = {
    readonly items: ServiceOption[];
    readonly hasMore: boolean;
};

export type ServiceOptionVehicle = {
    readonly id: VehicleId;
    readonly model?: ServiceOrderVehicleModel;
};

export type ServiceOptionLocation = {
    readonly timeZone: string;
    readonly identifier: string;
    readonly address?: Partial<Address>;
};

export type Service = {
    readonly type: ServiceType;
    readonly description?: string;
    readonly executionCount: number;
};

export type ServiceOption = {
    readonly id: string;
    readonly externalOrderId: string;
    readonly vehicle: ServiceOptionVehicle;
    readonly status: ServiceOptionStatus;
    readonly serviceLocation: ServiceOptionLocation;
    readonly orderIssuedAt: Date;
    readonly services: Service[];
};
